<template>
  <div class="nps-card" v-if="questions.length && groupNames.length">
    <div class="nps-card-title">Evaluacion 1-5 por {{ groupLabel }}: {{ questionList }}</div>
    <charts :options="chartOptions"></charts>
  </div>
</template>

<script>
export default {
  name: 'NpsReplicaGroupedAttributesSection',
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    records: {
      type: Array,
      default: function () {
        return [];
      }
    },
    groupKey: {
      type: String,
      default: 'cluster'
    },
    groupLabel: {
      type: String,
      default: 'Cluster'
    }
  },
  computed: {
    questionList () {
      return this.questions.map((item) => item.label).join(', ');
    },
    groupNames () {
      const names = {};

      this.records.forEach((record) => {
        const value = record && record.dimensions ? (record.dimensions[this.groupKey] || 'SIN_MAPEO') : 'SIN_MAPEO';
        names[value] = value;
      });

      return Object.keys(names).sort((left, right) => left.localeCompare(right));
    },
    chartOptions () {
      const colors = ['#E94560', '#6366F1', '#28A745', '#FFC107', '#8E24AA', '#26A69A'];

      return {
        chart: {
          type: 'bar',
          height: 260,
          spacing: [0, 0, 0, 0]
        },
        title: {
          text: null
        },
        yAxis: {
          min: 0,
          max: 5,
          title: {
            text: null
          },
          gridLineWidth: 1,
          gridLineColor: '#EEF0F5'
        },
        xAxis: {
          categories: this.questions.map((item) => item.label),
          title: {
            text: null
          }
        },
        credits: {
          enabled: false
        },
        series: this.groupNames.map((groupName, index) => ({
          name: groupName,
          data: this.questions.map((question) => this.averageForQuestion(question.campo, groupName)),
          color: colors[index % colors.length]
        }))
      };
    }
  },
  methods: {
    averageForQuestion (field, groupName) {
      let sum = 0;
      let count = 0;

      this.records.forEach((record) => {
        const currentGroup = record && record.dimensions ? (record.dimensions[this.groupKey] || 'SIN_MAPEO') : 'SIN_MAPEO';
        if (currentGroup !== groupName) {
          return;
        }

        const answer = record.answers && record.answers[field] ? record.answers[field] : null;
        if (answer && answer.numeric !== null) {
          sum += answer.numeric;
          count++;
        }
      });

      return count > 0 ? Number((sum / count).toFixed(2)) : 0;
    }
  }
};
</script>

<style scoped>
.nps-card {
  background: var(--bg-card, #FFFFFF);
  border-radius: 12px;
  box-shadow: var(--card-shadow, 0 2px 12px rgba(26,26,46,0.08));
  padding: 20px 22px;
}

.nps-card-title {
  color: var(--text-primary, #1A1A2E);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/GroupedAttributesSection.vue